const ChartIcon = ({ size = 24, color = "#444444", className = "" }) => {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} preserveAspectRatio="none" className={className}>
      <rect x="10" y="14" fill="none" stroke={color} strokeWidth="2" strokeLinecap="square" strokeMiterlimit="10" width="4" height="9" strokeLinejoin="miter" />
      <rect x="1" y="18" fill="none" stroke={color} strokeWidth="2" strokeLinecap="square" strokeMiterlimit="10" width="4" height="5" strokeLinejoin="miter" />
      <rect x="19" y="10" fill="none" stroke={color} strokeWidth="2" strokeLinecap="square" strokeMiterlimit="10" width="4" height="13" strokeLinejoin="miter" />
      <polyline fill="none" stroke={color} strokeWidth="2" strokeMiterlimit="10" points="3,10 8,5 12,9 20,1" strokeLinejoin="miter" strokeLinecap="butt" />
      <polyline fill="none" stroke={color} strokeWidth="2" strokeLinecap="square" strokeMiterlimit="10" points="15,1 20,1 20,6" strokeLinejoin="miter" />
    </svg>
  );
};

export default ChartIcon;
